module.exports = __webpack_public_path__ + "img/bghe55.2a61ed65.png";